import { useRouteLoaderData } from "~/hooks/useRouteLoaderData";

/**
 * Return the site that the user is currently on.
 */
export function useSite() {
  const { site } = useRouteLoaderData("routes/$site");
  return site;
}
